import React from 'react'
import { SubscriptionPurchasesTable } from '../subscription-purchases-table'
import { Box } from '@mui/material'

export const SubscriptionProductSubscribersTab = (props: any) => {
  const { id } = props
  return {
    name: 'Subscribers',
    path: `/activities/subscriptions/${id}/subscribers`,
    component: () => (
      <Box mb="40px">
        <SubscriptionPurchasesTable variant="product" productId={Number(id)} />
      </Box>
    ),
  }
}
